/*
  dtf-film-style-lock.js
  ─────────────────────────────────────────────────────────────────────────────
  DTF "Build Your Own Gang Sheet" PDP (template product.dtf-gang-sheet /
  build-a-gang-sheet, e.g. /products/build-your-own-gang-sheet).

  Problem: a backend process (an app or Shopify Flow with product write access)
  periodically re-sorts this product's variants in the admin, which reshuffles
  the "Select film style" swatches on the storefront (e.g. Glow in the Dark
  jumps to first) and can change which one comes up selected. The theme renders
  the swatches straight from the variant option values, so it inherits whatever
  order the admin currently holds.

  This LOCKS the storefront presentation regardless of the admin order:
    1. Fixed visual order via CSS `order` on the flex swatch items (keyed by the
       radio input value). Desktop + mobile; no DOM detach, so the theme/app
       listeners on the inputs stay intact. Re-applied if the picker re-renders.
    2. Defaults the selection to VIVID AF on a fresh load (only when there's no
       ?variant= deep link and something else came up selected).
    3. decorate(): wraps each film label's text in title/sub spans for the
       card-picker restyle (2026-08-13) — "Premium DTF / VIVID AF" etc. The
       matching CSS lives in assets/theme.css (FILM style card block).
    4. decorate() also injects a .nt-fsc-photo node per card (2026-08-14):
       a real printed-shirt example photo that theme.css floats above the
       card on desktop :hover (FILM-card hover-photo block). Photos are the
       product's own film-style gallery shots on the Shopify CDN.

  NOTE: storefront band-aid. The root cause is the admin re-sort — stopping that
  app/Flow is the real fix; this only governs this one PDP's UI.
*/
(function () {
  var TEMPLATE_RE = /template-product-(dtf-gang-sheet|build-a-gang-sheet)/;

  var ORDER = { 'VIVID AF': 1, 'Glitter': 2, 'Glow in the Dark': 3, 'Gold Foil': 4, 'Silver Foil': 5 };
  var DEFAULT_VALUE = 'VIVID AF';

  /* Card-picker text (2026-08-13 restyle): display title + small sub-brand
     line per film value. The radio VALUE stays untouched (cart/variant
     integrity) — this is display-only. Styled by the FILM-style card block
     in assets/theme.css. */
  var META = {
    'VIVID AF':         { title: 'Premium DTF', sub: 'VIVID AF' },
    'Glitter':          { sub: 'VIVID AF' },
    'Glow in the Dark': { sub: 'VIVID AF' },
    'Gold Foil':        { sub: '1 Color' },
    'Silver Foil':      { sub: '1 Color' }
  };

  /* Hover-photo card (2026-08-14): real printed-shirt example per film value,
     shown on desktop :hover by theme.css (FILM-card hover-photo block). These
     are the product's own film-style gallery images, resized/recompressed by
     the Shopify CDN (width=420 = 2x the 200px card; format=pjpg cuts the
     ~300KB PNGs to ~60KB — the shots are photos, no alpha needed). */
  var PHOTO = {
    'VIVID AF':         'https://cdn.shopify.com/s/files/1/0558/0265/8899/files/dtfcolor.png?v=1772640304&width=420&format=pjpg',
    'Glitter':          'https://cdn.shopify.com/s/files/1/0558/0265/8899/files/GlitterDTF1.png?v=1772039472&width=420&format=pjpg',
    'Glow in the Dark': 'https://cdn.shopify.com/s/files/1/0558/0265/8899/files/Glow_in_Dark_DTF_Transfers_22.png?v=1772039472&width=420&format=pjpg',
    'Gold Foil':        'https://cdn.shopify.com/s/files/1/0558/0265/8899/files/Gold_Foil_1_1.png?v=1772039472&width=420&format=pjpg',
    'Silver Foil':      'https://cdn.shopify.com/s/files/1/0558/0265/8899/files/silver_foil_1_1.png?v=1772039472&width=420&format=pjpg'
  };

  function filmGroup() {
    var groups = document.querySelectorAll('.product-variant');
    for (var i = 0; i < groups.length; i++) {
      var name = groups[i].querySelector('.product-variant__name');
      if (name && /film style/i.test(name.textContent)) return groups[i];
    }
    return null;
  }

  // Pin visual order on the flex swatch items by each radio's value.
  function lockOrder() {
    var g = filmGroup(); if (!g) return;
    var items = g.querySelectorAll('.product-variant__item');
    for (var i = 0; i < items.length; i++) {
      var inp = items[i].querySelector('input');
      if (!inp) continue;
      var o = ORDER[(inp.value || '').trim()];
      if (o) items[i].style.order = String(o);
    }
  }

  // Wrap each film label's raw text in title/sub spans for the card layout.
  // Idempotent (skips labels already carrying .nt-fsc-text); safe to re-run
  // after the theme's variant re-render rebuilds the picker DOM. The <img>
  // swatch stays in place — theme.css swaps its rendered content for the
  // VIVID wheel / holo glitter.
  function decorate() {
    var g = filmGroup(); if (!g) return;
    var items = g.querySelectorAll('.product-variant__item');
    for (var i = 0; i < items.length; i++) {
      var inp = items[i].querySelector('input');
      var label = items[i].querySelector('label');
      if (!inp || !label) continue;
      var val = (inp.value || '').trim();
      // Hover photo (see header note 4): injected on the ITEM, not the label,
      // so the label text-node scan below never touches it. createElement, not
      // innerHTML (Yottaa mangles innerHTML-built markup). Idempotent per item.
      // A theme-editor image picker (section settings "Film hover photos")
      // stamps data-nt-fsc-photo on the item and overrides the built-in map.
      var photoSrc = items[i].getAttribute('data-nt-fsc-photo') || PHOTO[val];
      if (photoSrc && !items[i].querySelector('.nt-fsc-photo')) {
        var ph = document.createElement('span');
        ph.className = 'nt-fsc-photo';
        var pimg = document.createElement('img');
        pimg.src = photoSrc;
        pimg.alt = ((META[val] && META[val].title) || val) + ' printed example';
        pimg.loading = 'lazy';
        pimg.decoding = 'async';
        pimg.width = 420;
        pimg.height = 420;
        ph.appendChild(pimg);
        items[i].appendChild(ph);
      }
      if (label.querySelector('.nt-fsc-text')) continue;
      var raw = '';
      var nodes = label.childNodes;
      for (var k = nodes.length - 1; k >= 0; k--) {
        if (nodes[k].nodeType === 3) { raw += nodes[k].textContent; label.removeChild(nodes[k]); }
      }
      raw = raw.replace(/\s+/g, ' ').trim();
      var meta = META[val] || {};
      var txt = document.createElement('span');
      txt.className = 'nt-fsc-text';
      var t = document.createElement('span');
      t.className = 'nt-fsc-title';
      t.textContent = meta.title || raw || inp.value;
      txt.appendChild(t);
      if (meta.sub) {
        var sb = document.createElement('span');
        sb.className = 'nt-fsc-sub';
        sb.textContent = meta.sub;
        txt.appendChild(sb);
      }
      label.appendChild(txt);
    }
  }

  // Default to VIVID AF on a fresh load (respect ?variant= deep links).
  function setDefault() {
    if (/[?&]variant=/.test(location.search)) return;
    var g = filmGroup(); if (!g) return;
    var inputs = g.querySelectorAll('input');
    var vivid = null;
    for (var i = 0; i < inputs.length; i++) {
      if ((inputs[i].value || '').trim() === DEFAULT_VALUE) { vivid = inputs[i]; break; }
    }
    if (vivid && !vivid.checked) {
      vivid.checked = true;
      vivid.dispatchEvent(new Event('input', { bubbles: true }));
      vivid.dispatchEvent(new Event('change', { bubbles: true }));
      // Pre-DCL flip: the theme's film-change handlers (e.g. the "For Foil
      // Prints" note toggle) attach later from deferred scripts and miss
      // this dispatch — re-fire it once at DOMContentLoaded so every
      // late-bound listener syncs to the defaulted film.
      pendingResync = (document.readyState === 'loading');
    }
  }

  var pendingResync = false;
  function resyncListeners() {
    if (!pendingResync) return;
    pendingResync = false;
    var g = filmGroup(); if (!g) return;
    var checked = g.querySelector('input:checked');
    if (!checked) return;
    checked.dispatchEvent(new Event('input', { bubbles: true }));
    checked.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function apply() {
    lockOrder();
    decorate();
    // Release the pre-JS FOUC guards (theme.css paints CSS titles and
    // suppresses a stale server-checked highlight until this class exists).
    // Stamp only once every present item is decorated, so the guards keep
    // covering while the picker's items are still streaming in during parse.
    // Re-added after every re-render since the theme replaces the container.
    var g = filmGroup();
    var c = g && g.querySelector('.product-variant__container');
    if (!c) return;
    var items = c.querySelectorAll('.product-variant__item');
    for (var i = 0; i < items.length; i++) {
      var label = items[i].querySelector('label');
      if (label && !label.querySelector('.nt-fsc-text')) return;
    }
    if (items.length) c.classList.add('nt-fsc-ready');
  }

  /* This file loads WITHOUT defer (theme.liquid) so it runs before the body
     parses: a document-wide MutationObserver decorates/orders the film items
     the moment they stream in, and defaults the selection as soon as the
     VIVID AF radio exists — all before that region's first paint. That kills
     the "VIVID AF flashes before Premium DTF / the grey sub pops in" FOUC on
     the builder + upload (2026-08-13). Callbacks run synchronously (no
     throttle): the work is idempotent and O(5). */
  var defaulted = false;
  function tick() {
    var g = filmGroup();
    if (!g) return;
    apply();
    if (!defaulted && g.querySelector('input[value="' + DEFAULT_VALUE + '"]')) {
      defaulted = true;
      setDefault();
      apply();
    }
  }

  function begin() {
    if (!TEMPLATE_RE.test(document.body.className || '')) return;
    tick();
    // Microtask-coalesced: still runs before paint, but parse-time mutation
    // bursts collapse into a handful of ticks (decorate/lockOrder only write
    // when something actually changes, so no observer feedback loop).
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      queueMicrotask(function () { queued = false; tick(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', function () { tick(); resyncListeners(); });
    [400, 1200, 2500].forEach(function (ms) { setTimeout(tick, ms); });
  }

  if (document.body) begin();
  else new MutationObserver(function (m, o) {
    if (document.body) { o.disconnect(); begin(); }
  }).observe(document.documentElement, { childList: true });
})();
